@if (loading) {
<div class="px-2 sm:px-0">
  <div class="flex flex-wrap justify-center mx-3">
    <ngx-skeleton-loader
      [count]="8"
      [theme]="{height: '180px',width:'362px' , 'border-radius': '12px',  }"
    ></ngx-skeleton-loader>
  </div>
</div>
} @if (error) {
<div class="text-center py-6 text-red-500">
  {{ error }}
</div>
}

<!-- Mostrar mensaje cuando no hay productos filtrados -->
@if (!loading && !error && products.length === 0) {
<shared-empty-products-establishment class="flex justify-center py-6">
</shared-empty-products-establishment>
} @if (products.length > 0) {
<div class="px-2 sm:px-0">
  <establishment-main-products
    [isOpen]="isOpen"
    [products]="products"
  ></establishment-main-products>
</div>
}
